import { WithPermissions } from 'react-admin';
import { ReactElement, ReactNode } from 'react';
import { Permission, PermissionData } from 'src/pages/admin/entities/permission.entity';
import { LoadingScreen } from 'src/components/loading-screen';

interface PermissionGuardProps {
  resource?: string;
  action?: string;
  anyOf?: { resource: string; action: string }[];
  children: ReactNode;
  fallback?: ReactNode;
  loadingFallback?: ReactNode;
}

export const PermissionGuard = ({
  resource,
  action,
  anyOf,
  children,
  fallback = <>You do not have permission to access this page.</>,
  loadingFallback = <LoadingScreen />,
}: PermissionGuardProps): ReactElement => {
  return (
    <WithPermissions
      render={({ permissions }) => {
        if(!permissions || permissions === undefined) {
          return <>{loadingFallback}</>;
        }
        const data = permissions as PermissionData;
        const permissionList = data?.permissions || [];

        const allowed =
          (resource && action &&
            permissionList.some(
              (perm: Permission) =>
                (perm.resource === resource || perm.resource === '*') &&
                (perm.action.includes(action) || perm.action.includes('*'))
            )) ||
          (anyOf &&
            anyOf.some((item) =>
              permissionList.some(
                (perm: Permission) =>
                  (perm.resource === item.resource || perm.resource === '*') &&
                  (perm.action.includes(item.action) || perm.action.includes('*'))
              )
            ));

        return allowed ? <>{children}</> : <>{fallback}</>;
      }}
    />
  );
};
